import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { createPinia, PiniaVuePlugin } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueTheMask from "vue-the-mask";
import VueResource from "vue-resource";
import { BASE_URL } from "@/http/url";
import money from "v-money";
import moment from "moment";
import Print from "vue-print-nb";
import VueHtml2pdf from "vue-html2pdf";
import VueApexCharts from "vue-apexcharts";

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(PiniaVuePlugin);
Vue.use(VueTheMask);
Vue.use(VueResource);
Vue.use(money);
Vue.use(Print);
Vue.use(VueHtml2pdf);
Vue.use(VueApexCharts);

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);
Vue.config.productionTip = false;
Vue.http.options.root = BASE_URL;
Vue.prototype.moment = moment;

require("./assets/main.scss");

new Vue({
  router,
  pinia,
  render: (h) => h(App),
}).$mount("#app");
